import { LOGGED_OUT_CODE_GENERATOR_V2_TEST } from '@dtx-company/true-common/src/constants/experiments'
import { useFlowExperiment } from '@dtx-company/inter-app/src/hooks/useFlowExperiment/useFlowExperiment'

type Variations = 'control' | 'new_locg_variant' | 'removal_variant'

export const useLoggedOutGeneratorV2Experiment = (): Variations => {
  const [variation] = useFlowExperiment(LOGGED_OUT_CODE_GENERATOR_V2_TEST, { autoUpdate: true })
  return variation as Variations
}
